import React from 'react';
import { SiteContent } from '../data/content';

interface CasesProps {
  content: SiteContent['casesSection'];
}

export const Cases: React.FC<CasesProps> = ({ content }) => {
  return (
    <section className="cases-section" id="cases" aria-labelledby="cases-title">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 id="cases-title" className="section-title">
            {content.title} <em>{content.titleEmphasis}</em>
          </h2>
        </div>

        <div className="cases-editorial-stack">
          {content.items.map((c) => (
            <article key={c.id} className="case-editorial-entry">
              <span className="case-tag-mono">{c.tag}</span>
              <h3 className="case-title">{c.title}</h3>

              <div className="case-quad-grid">
                <div className="case-quad-cell">
                  <span className="quad-label">{content.labels.problem}</span>
                  <p className="quad-text">{c.problem}</p>
                </div>
                <div className="case-quad-cell">
                  <span className="quad-label">{content.labels.constraint}</span>
                  <p className="quad-text">{c.constraint}</p>
                </div>
                <div className="case-quad-cell">
                  <span className="quad-label">{content.labels.action}</span>
                  <p className="quad-text">{c.action}</p>
                </div>
                <div className="case-quad-cell">
                  <span className="quad-label">{content.labels.result}</span>
                  <p className="quad-text">{c.result}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
